module.exports = __webpack_public_path__ + "static/media/roundaboutCW270.d7695b48.svg";